import React, { useEffect, useReducer, useState } from "react";
import { Collapse, Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaReact } from "react-icons/fa";
import { getUserInfoDetailsByUserId } from "../../../store/slices/userSlice";
import { useSelector, useDispatch } from "react-redux";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const [state, setState] = useReducer(reducer, initialState);
  const sideMenu = useSelector((state) => state.sidebarMenu);
  const [hover, setHover] = useState(false);
  const [heartBtn, setHeartBtn] = useState();
  const date = new Date();
  const dispatch = useDispatch();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { userInfoDetails } = useSelector((state) => state.users);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const userId = userInfo?._id;
    // const userType = Number(sessionStorage.getItem("userType"));
const [userType, setUserType] = useState(null);
useEffect(() => {
  const type = Number(sessionStorage.getItem("userType"));
  setUserType(type);
}, []);
useEffect(() => {
  if (userId && userType) {
    dispatch(
      getUserInfoDetailsByUserId({
        userId,
        token,
        userType,
        searchTerm: searchValue,
        applicationId: 2,
      })
    );
  }
}, [dispatch, userId, token, searchValue, userType]);

  const handleSearch = (e) => {
    const searchQuery = e.target.value.toLowerCase();
    if (!searchQuery) {
      setSearchValue("");
    } else {
      setSearchValue(searchQuery);
    }
  };

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state?.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state?.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  const handleNavigate = (pageName) => {
    sessionStorage.setItem("pageName", pageName);
    navigate(pageName);
  };
  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {!sideMenu ? (
            <div className="form-head d-flex mb-3 align-items-center justify-content-center">
              <div className="input-group search-area d-inline-flex border shadow-sm rounded">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search here"
                  onChange={(e) => handleSearch(e)}
                  style={{
                    height: "38px",
                    padding: "0 0 0 0.8rem",
                    fontSize: "14px",
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="input-group-text"
                    style={{
                      padding: "0",
                    }}
                  >
                    <FaSearch className="text-info" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="text-center"
              style={{
                position: "relative",
                cursor: "pointer",
                fontSize: "1.1rem",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <FaSearch className="text-info" />
              {hover && (
                <div
                  style={{
                    position: "absolute",
                    top: "0%",
                    left: "100%",
                    width: "11rem",
                    zIndex: "1",
                  }}
                >
                  <div className="form-head d-flex mb-2 align-items-start">
                    <div className="input-group search-area ms-auto d-inline-flex me-3 border shadow-sm">
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search here"
                        onChange={(e) => handleSearch(e)}
                        style={{
                          height: "38px",
                          padding: "0 0 0 0.8rem",
                          fontSize: "14px",
                        }}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="input-group-text"
                          style={{
                            padding: "0",
                          }}
                        >
                          <FaSearch className="text-info" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {userInfoDetails &&
            userInfoDetails?.map((item, index) => {
              const parentModule = item?.parentModule;
              let menuClass = item?.classsChange;
              if (menuClass === "menu-title") {
                return (
                  <>
                    {parentModule?.isShowSideBar === "Yes" && (
                      <li className={menuClass} key={index}>
                        {parentModule?.title}
                      </li>
                    )}
                  </>
                );
              } else {
                return (
                  parentModule?.isShowSideBar === "Yes" && (
                    <li
                      className={`has-menu ${
                        state.active === parentModule?.title ? "mm-active" : ""
                      }`}
                      key={index}
                    >
                      {item?.childModules && item?.childModules?.length > 0 ? (
                        <Link
                          to={"#"}
                          className="has-arrow ai-icon d-flex justify-content-between"
                          onClick={() => handleMenuActive(parentModule?.title)}
                        >
                          <div>
                            {parentModule?.icon ? (
                              <Image
                                src={parentModule?.icon}
                                alt={`${parentModule?.title}`}
                                className="img-thumbnail"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  marginRight: "6px",
                                }}
                              />
                            ) : (
                              <FaReact
                                style={{
                                  color:
                                    state.active === parentModule?.title
                                      ? "#fff"
                                      : "#5921cf",
                                }}
                              />
                            )}
                            <span className="nav-text">
                              {parentModule?.title}
                            </span>
                          </div>
                          {state.active === parentModule?.title ? (
                            <MdKeyboardArrowDown />
                          ) : (
                            <MdKeyboardArrowRight />
                          )}
                        </Link>
                      ) : (
                        <Link
                          to={parentModule?.pageUrl}
                          onClick={() => handleNavigate(parentModule?.title)}
                        >
                          {parentModule?.icon ? (
                            <Image
                              src={parentModule?.icon}
                              alt={`${parentModule?.title}`}
                              className="img-thumbnail"
                              style={{
                                width: "25px",
                                height: "25px",
                                marginRight: "6px",
                              }}
                            />
                          ) : (
                            <FaReact style={{ color: "#5921cf" }} />
                          )}
                          <span className="nav-text">
                            {parentModule?.title}
                          </span>
                        </Link>
                      )}
                      <Collapse
                        in={state.active === parentModule?.title ? true : false}
                      >
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          <Link
                            to={parentModule?.pageUrl}
                            onClick={() => handleNavigate(parentModule?.title)}
                          >
                            {/* {parentModule.iconStyle}{" "} */}
                            <Image
                              src={parentModule?.icon}
                              alt={`${parentModule?.title}`}
                              className="img-thumbnail"
                              style={{
                                width: "25px",
                                height: "25px",
                                marginRight: "6px",
                              }}
                            />
                            <span className="nav-text">
                              {parentModule?.title} List
                            </span>
                          </Link>
                          {item?.childModules &&
                            item?.childModules?.map((childData, index) => {
                              return (
                                <>
                                  {childData?.isShowSideBar === "Yes" && (
                                    <li
                                      key={index}
                                      className={`${
                                        state.activeSubmenu === childData?.title
                                          ? "mm-active"
                                          : ""
                                      }`}
                                    >
                                      {childData?.subChildModules &&
                                      childData?.subChildModules.length > 0 ? (
                                        <>
                                          <Link
                                            to={childData?.childPageUrl}
                                            className={
                                              " d-flex justify-content-between align-items-center"
                                            }
                                            onClick={() => {
                                              handleSubmenuActive(
                                                childData?.title,
                                              );
                                            }}
                                          >
                                            <div>
                                              {childData?.icon ? (
                                                <Image
                                                  src={childData?.icon}
                                                  alt={`${childData?.title}`}
                                                  className="img-thumbnail"
                                                  style={{
                                                    width: "23px",
                                                    height: "23px",
                                                    marginRight: "6px",
                                                  }}
                                                />
                                              ) : (
                                                <FaReact
                                                  style={{
                                                    color: "#5921cf",
                                                    fontSize: "1.25rem",
                                                    marginRight: "0.09rem",
                                                  }}
                                                />
                                              )}
                                              <span className="nav-text">
                                                {" "}
                                                {childData?.title}{" "}
                                              </span>
                                            </div>
                                            {state.activeSubmenu ===
                                            childData?.title ? (
                                              <MdKeyboardArrowDown size={19} />
                                            ) : (
                                              <MdKeyboardArrowRight size={19} />
                                            )}
                                          </Link>
                                          <Collapse
                                            in={
                                              state.activeSubmenu ===
                                              childData?.title
                                                ? true
                                                : false
                                            }
                                          >
                                            <ul
                                              className={`${
                                                menuClass === "mm-collapse"
                                                  ? "mm-show"
                                                  : ""
                                              }`}
                                            >
                                              <li
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <Link
                                                  to={childData?.pageUrl}
                                                  onClick={() =>
                                                    handleNavigate(
                                                      childData?.title,
                                                    )
                                                  }
                                                >
                                                  <Image
                                                    src={childData?.icon}
                                                    alt={`${childData?.title}`}
                                                    className="img-thumbnail"
                                                    style={{
                                                      width: "25px",
                                                      height: "25px",
                                                      marginRight: "6px",
                                                    }}
                                                  />
                                                  <span className="nav-text">
                                                    {childData?.title} List
                                                  </span>
                                                </Link>
                                              </li>
                                              {childData?.subChildModules &&
                                                childData?.subChildModules?.map(
                                                  (subChildData, index) => {
                                                    return (
                                                      subChildData?.isShowSideBar ===
                                                        "Yes" && (
                                                        <li key={index}>
                                                          <Link
                                                            to={
                                                              subChildData?.pageUrl
                                                            }
                                                            onClick={() =>
                                                              handleNavigate(
                                                                subChildData?.title,
                                                              )
                                                            }
                                                            className={`${
                                                              path ===
                                                              subChildData.subChildPageUrl
                                                                ? "mm-active"
                                                                : "submenu"
                                                            }`}
                                                          >
                                                            {subChildData?.icon ? (
                                                              <Image
                                                                src={
                                                                  subChildData?.icon
                                                                }
                                                                alt={`${subChildData?.title}`}
                                                                className="img-thumbnail"
                                                                style={{
                                                                  width: "21px",
                                                                  height:
                                                                    "21px",
                                                                  marginRight:
                                                                    "6px",
                                                                }}
                                                              />
                                                            ) : (
                                                              <FaReact
                                                                style={{
                                                                  color:
                                                                    "#5921cf",
                                                                  marginRight:
                                                                    "0.3rem",
                                                                  fontSize:
                                                                    "1.05rem",
                                                                }}
                                                              />
                                                            )}
                                                            {
                                                              subChildData?.title
                                                            }
                                                          </Link>
                                                        </li>
                                                      )
                                                    );
                                                  },
                                                )}
                                            </ul>
                                          </Collapse>
                                        </>
                                      ) : (
                                        <Link
                                          to={childData?.pageUrl}
                                          onClick={() =>
                                            handleNavigate(childData?.title)
                                          }
                                        >
                                          {childData?.icon ? (
                                            <Image
                                              src={childData?.icon}
                                              alt={`${parentModule?.title}`}
                                              className="img-thumbnail"
                                              style={{
                                                width: "23px",
                                                height: "23px",
                                                marginRight: "6px",
                                              }}
                                            />
                                          ) : (
                                            <FaReact
                                              style={{
                                                color: "#5921cf",
                                                fontSize: "1.25rem",
                                                marginRight: "0.3rem",
                                              }}
                                            />
                                          )}
                                          {childData?.title}
                                        </Link>
                                      )}
                                    </li>
                                  )}
                                </>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </li>
                  )
                );
              }
            })}
        </ul>
        <div className="plus-box">
          <p className="fs-16 font-w500 mb-1">Confer</p>
          <Link to={"#"} className="text-white fs-26">
            <i className="las la-long-arrow-alt-right" />
          </Link>
        </div>
        <div className="copyright">
          <p>
            Copyright © Designed &amp; Developed by
            <a href="https://simpleelabs.com/" target="_blank" rel="noreferrer">
              <span className="ms-1 me-1">SimpleeLabs</span>
            </a>
            {date.getFullYear()}
          </p>
          <p>
            Made with{" "}
            <span
              className={`heart ${heartBtn ? "heart-blast" : ""}`}
              onClick={() => setHeartBtn(!heartBtn)}
            ></span>{" "}
            by SimpleeLabs
          </p>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
